import {
  CREATE_CUSTOMER_REPORT_RESPONSE,
  GET_CUSTOMER_REPORT_RESPONSE,
  GET_CUSTOMER_REPORT_ACTION_RESPONSE,
  SET_CURRENT_STAGE,
  SET_CURRENT_STAGE_ATTRIBUTES,
} from 'actions/grace';

const initialState = {
  currentStage: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CUSTOMER_REPORT_RESPONSE:
    case GET_CUSTOMER_REPORT_RESPONSE:
      return { currentStage: action.response.customerReport.nextStage };
    case GET_CUSTOMER_REPORT_ACTION_RESPONSE:
      return { currentStage: action.response.resolver.nextStage };
    case SET_CURRENT_STAGE:
      return { currentStage: action.payload };
    case SET_CURRENT_STAGE_ATTRIBUTES:
      return { currentStage: { ...state, ...action.payload } };
    default:
      return state;
  }
};
